"use client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRouter } from "next/navigation";
import supabase from "@/lib/supabase/client";
import { logoutTracker } from "@/lib/auth/logoutTracker";
import { handleSessionEnd } from "@/lib/auth/handleSessionEnd";

// 로그아웃 Mutation
export const useLogoutMutation = () => {
  const queryClient = useQueryClient();
  const router = useRouter();

  return useMutation({
    mutationFn: async () => {
      logoutTracker.setManualLogout(true);

      // 팀 관리자 unlock 쿠키 삭제 (httpOnly 쿠키이므로 서버 API 호출 필요)
      try {
        await fetch("/api/team-admin/lock", { method: "POST" });
      } catch {}

      const { error } = await supabase.auth.signOut();
      if (error) {
        // 에러 발생 시 플래그 원상 복구
        logoutTracker.setManualLogout(false);
        throw error;
      }
    },

    onSuccess: () => {
      // AuthListener가 SIGNED_OUT 이벤트를 감지하고 리다이렉트 처리
      handleSessionEnd(queryClient, router);
    },
  });
};

export const useLogout = () => {
  const logoutMutation = useLogoutMutation();

  const logout = () => {
    // 확인 다이얼로그 없이 바로 로그아웃 실행
    logoutMutation.mutate();
  };

  return {
    logout,
    isLoggingOut: logoutMutation.isPending,
  };
};
